import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import {
  UpdateOutlined,
  VisibilityOutlined,
  MoneyOffOutlined,
  VerifiedOutlined,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const TrustStrip = () => {
  const { t } = useTranslation();
  const { lng } = useParams();
  const items = [
    { icon: UpdateOutlined, label: t('trustStrip.dataUpdated') },
    { icon: VisibilityOutlined, label: t('trustStrip.methodology'), to: `/${lng}/como-monetizamos` },
    { icon: MoneyOffOutlined, label: t('trustStrip.freeForUsers') },
    { icon: VerifiedOutlined, label: t('trustStrip.verifiedProducts') },
  ];
  return (
    <Box
      sx={{
        backgroundColor: '#FAFBFC',
        borderTop: 'none',
        borderBottom: 'none',
        py: { xs: 1.5, md: 2 },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: { xs: 3, md: 6 },
          }}
        >
          {items.map((item) => {
            const IconComponent = item.icon;
            const content = (
              <Box
                key={item.label}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  transition: 'opacity 0.2s ease',
                  '&:hover': item.to ? { opacity: 0.7 } : {},
                }}
              >
                <IconComponent sx={{ fontSize: 16, color: '#5F6B7A' }} />
                <Typography
                  sx={{
                    fontSize: '13px',
                    color: '#5F6B7A',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            );

            if (item.to) {
              return (
                <Box
                  key={item.label}
                  component={RouterLink}
                  to={item.to}
                  sx={{ textDecoration: 'none', color: 'inherit' }}
                >
                  {content}
                </Box>
              );
            }
            return <React.Fragment key={item.label}>{content}</React.Fragment>;
          })}
        </Box>
      </Container>
    </Box>
  );
};

export default TrustStrip;
